(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    var mapDivs = document.querySelectorAll('.playnia-map');
    if (!mapDivs.length) return;
    
    mapDivs.forEach(function(mapDiv) {
      var city = mapDiv.dataset.city;
      var lat = parseFloat(mapDiv.dataset.lat) || 52.23;
      var lon = parseFloat(mapDiv.dataset.lon) || 21.01;
      var zoom = parseInt(mapDiv.dataset.zoom) || 12;
      var jsonUrl = mapDiv.dataset.json;
      
      if (!jsonUrl) return;
      
      // Create map container
      var container = document.createElement('div');
      container.className = 'pm-container';
      
      // Filter bar
      var filterBar = document.createElement('div');
      filterBar.className = 'pm-filters';
      filterBar.innerHTML = '<div class="pm-filter-title">Filtruj place zabaw:</div>' +
        '<div class="pm-filter-row">' +
        '<label class="pm-chip pm-chip--active" data-filter="all"><input type="checkbox" checked> Wszystkie</label>' +
        '<label class="pm-chip" data-filter="fenced"><input type="checkbox"> Ogrodzony</label>' +
        '<label class="pm-chip" data-filter="lit"><input type="checkbox"> O\u015bwietlony</label>' +
        '<label class="pm-chip" data-filter="wheelchair"><input type="checkbox"> Dost\u0119pny</label>' +
        '<label class="pm-chip" data-filter="rubber"><input type="checkbox"> Mata gumowa</label>' +
        '<label class="pm-chip" data-filter="sand"><input type="checkbox"> Piasek</label>' +
        '</div>' +
        '<div class="pm-count">\u0141adowanie danych...</div>';
      container.appendChild(filterBar);
      
      // Map div
      var mapEl = document.createElement('div');
      mapEl.className = 'pm-map';
      mapEl.id = 'pm-map-' + city;
      container.appendChild(mapEl);
      
      mapDiv.appendChild(container);
      
      // Initialize Leaflet map
      var map = L.map(mapEl.id).setView([lat, lon], zoom);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a>',
        maxZoom: 18
      }).addTo(map);
      
      // Custom icons
      var orangeIcon = L.divIcon({
        className: 'pm-marker pm-marker--default',
        iconSize: [12, 12],
        iconAnchor: [6, 6]
      });
      var greenIcon = L.divIcon({
        className: 'pm-marker pm-marker--fenced',
        iconSize: [14, 14],
        iconAnchor: [7, 7]
      });
      
      // Load data
      var allMarkers = [];
      var countEl = container.querySelector('.pm-count');
      
      fetch(jsonUrl)
        .then(function(r) { return r.json(); })
        .then(function(playgrounds) {
          playgrounds.forEach(function(pg) {
            if (!pg.lat || !pg.lon) return;
            
            var icon = pg.fenced === 'yes' ? greenIcon : orangeIcon;
            var name = pg.name || 'Plac zabaw';
            
            var tags = '';
            if (pg.fenced === 'yes') tags += '<span class="pm-tag pm-tag--fenced">Ogrodzony</span> ';
            if (pg.lit === 'yes') tags += '<span class="pm-tag pm-tag--lit">O\u015bwietlony</span> ';
            if (pg.wheelchair === 'yes') tags += '<span class="pm-tag pm-tag--access">Dost\u0119pny</span> ';
            if (pg.surface) {
              var sMap = {sand:'Piasek',rubber:'Mata gumowa',grass:'Trawa',tartan:'Tartan',wood_chips:'Kora'};
              tags += '<span class="pm-tag pm-tag--surface">' + (sMap[pg.surface] || pg.surface) + '</span> ';
            }
            if (!tags) tags = '<span class="pm-tag">Publiczny</span>';
            
            var popup = '<div class="pm-popup">' +
              '<strong>' + name + '</strong>' +
              '<div class="pm-popup-tags">' + tags + '</div>' +
              '<a href="https://www.google.com/maps/search/?api=1&query=' + pg.lat + ',' + pg.lon + '" target="_blank" rel="noopener" class="pm-popup-nav">Nawiguj \u2192</a>' +
              '</div>';
            
            var marker = L.marker([pg.lat, pg.lon], {icon: icon}).bindPopup(popup);
            marker._pgData = pg;
            marker.addTo(map);
            allMarkers.push(marker);
          });
          
          countEl.textContent = 'Pokazuje ' + allMarkers.length + ' z ' + playgrounds.length + ' plac\u00f3w zabaw';
          
          // Filter logic
          var chips = container.querySelectorAll('.pm-chip');
          chips.forEach(function(chip) {
            chip.addEventListener('click', function(e) {
              var filter = this.dataset.filter;
              var cb = this.querySelector('input');
              
              if (filter === 'all') {
                chips.forEach(function(c) {
                  if (c.dataset.filter !== 'all') {
                    c.querySelector('input').checked = false;
                    c.classList.remove('pm-chip--active');
                  }
                });
                cb.checked = true;
                this.classList.add('pm-chip--active');
              } else {
                var allCb = container.querySelector('[data-filter="all"] input');
                allCb.checked = false;
                container.querySelector('[data-filter="all"]').classList.remove('pm-chip--active');
                this.classList.toggle('pm-chip--active');
              }
              
              applyFilters();
            });
          });
          
          function applyFilters() {
            var allChecked = container.querySelector('[data-filter="all"] input').checked;
            var activeFilters = [];
            chips.forEach(function(c) {
              if (c.dataset.filter !== 'all' && c.querySelector('input').checked) {
                activeFilters.push(c.dataset.filter);
              }
            });
            
            var visible = 0;
            allMarkers.forEach(function(marker) {
              var pg = marker._pgData;
              var show = false;
              
              if (allChecked || activeFilters.length === 0) {
                show = true;
              } else {
                show = activeFilters.every(function(f) {
                  if (f === 'fenced') return pg.fenced === 'yes';
                  if (f === 'lit') return pg.lit === 'yes';
                  if (f === 'wheelchair') return pg.wheelchair === 'yes';
                  if (f === 'rubber') return pg.surface === 'rubber';
                  if (f === 'sand') return pg.surface === 'sand';
                  return true;
                });
              }
              
              if (show) {
                if (!map.hasLayer(marker)) marker.addTo(map);
                visible++;
              } else {
                if (map.hasLayer(marker)) map.removeLayer(marker);
              }
            });
            
            countEl.textContent = 'Pokazuje ' + visible + ' z ' + allMarkers.length + ' plac\u00f3w zabaw';
          }
        })
        .catch(function(e) {
          countEl.textContent = 'B\u0142\u0105d \u0142adowania danych mapy';
          console.error('Playnia map error:', e);
        });
    });
  });
})();